export enum BatheType {
    None = 3,
    First = 1,
    Priority = 2,
    Last = 4
}

export enum StartOfWeek {
    Monday = 1,
    Sunday = 2
}

export enum BatheMethodOption {
    Normal = 1,         // 普通浴、
    Private = 2,        // 個浴、
    Chair = 3,          // チェアー浴、
    Lift = 4,           // リフト浴、
    Stretcher = 5,      // ストレッチャー浴、
    Bed = 6,            // 臥床浴、
    Shower = 7,         // シャワー浴
}

export enum BathRoomRule {
    None = 0,
    WomenFirst = 1,
    MenFirst = 2
}

export interface BathRuleType {
    code: string | null;
    text: string | null;
}

export interface BathRule {
    id: string | null;
    selected: string | null;
    type: BathRuleType;
    priority: string | null;
}

export class BathDailyModel {
    corpcd!: string;
    officecd!: string;
    blockcd!: string;
    subcd!: string;
    unitcd!: string;
    daicd!: string;
    bathRoomCd!: string;
    bathDate!: Date;

    bathMethodCd?: number | null = null;
    sortNo?: number | null = null;
    insStfcd?: string | null = null;
    insDate?: Date | null = null;
    updStfcd?: string | null = null;
    updDate?: Date | null = null;
}

export class BathDaiModel {
    corpCd!: string;
    officeCd!: string;
    blockCd!: string;
    subCd!: string;
    unitCd!: string;
    daiCd!: string;
    bathRoomCd!: string;

    daiFamily?: string | null = null;
    daiGiven?: string | null = null;
    bathMethodCd?: number | null = null;
    bathWeeks?: string | null = null;
    bathDays?: string | null = null;
    priorityCd?: number | null = null;
    treatmentNotes?: string | null = null;
    sortNo?: number | null = null;
    insStfCd?: string | null = null;
    insDate?: Date | null = null;
    updStfCd?: string | null = null;
    updDate?: Date | null = null;
}

export class BathRoomModel {
    corpCd!: string;
    officeCd!: string;
    blockCd!: string;
    subCd!: string;
    unitCd!: string;
    bathRoomCd!: string;

    bathName?: string | null = null;
    capacity?: number | null = null;
    sortNo?: number | null = null;
    bathRule?: string | null = null;
    bathRuleXMLValue?: BathRule[] | null = null;
    insStfCd?: string | null = null;
    insDate?: Date | null = null;
    updStfCd?: string | null = null;
    updDate?: Date | null = null;
}

export class BathRoomSummary extends BathRoomModel {
    daiList: string[] = [];
}

export class InsertOrUpdateBathRoomModel extends BathRoomModel {
    bathDaiList: BathDaiModel[] = [];

    constructor(data?: Partial<InsertOrUpdateBathRoomModel>) {
        super();
        Object.assign(this, data);
        this.bathDaiList = data?.bathDaiList?.map(x => new BathDaiModel()) || [];
    }
}

export class ExtendedBathDaiModel {
    // Properties from BathDaiModel (made optional)
    corpCd?: string | null = null;
    officeCd?: string | null = null;
    blockCd?: string | null = null;
    subCd?: string | null = null;
    unitCd?: string | null = null;
    daiCd?: string | null = null;
    bathRoomCd?: string | null = null;
    bathMethodCd?: number | null = null;
    bathWeeks?: string | null = null;
    bathDays?: string | null = null;
    priorityCd?: number | null = null;
    treatmentNotes?: string | null = null;
    sortNo?: number | null = null;
    insStfCd?: string | null = null;
    insDate?: Date | null = null;
    updStfCd?: string | null = null;
    updDate?: Date | null = null;

    // Extended properties
    daiFamily?: string | null = null;
    daiGiven?: string | null = null;
    fullNameHiragana?: string | null = null;

    name?: string | null = null;
    gender?: '男' | '女' = '男';
    avatar?: string | null = null;
    lastBatheDate?: string | null = null;
    nextBatheDate?: string | null = null;
    priority?: string | null = null;
    notifications?: string[] | null = null;
    batheMethod?: string | null = null;
    batheTimeConfig?: string | null = null;
    remarks?: string | null = null;
    hasDelivery?: boolean = false;
    hasAlert?: boolean = false;
    hasNotification?: boolean = false;
    isModified?: boolean = false; // Track if item was modified in current weekly mode session
    isValidForDisplay?: boolean = true; // Track if item is valid for display based on yotei (maps from DAIS.ISVALID)

    constructor(data?: Partial<ExtendedBathDaiModel>) {
        Object.assign(this, data);
    }
}

export interface BatheImplement {
    corpCd: string;
    officeCd: string;
    blockCd: string;
    subCd: string;
    unitCd: string;
    daiCd: string;
    bathRoomCd: number;
    bathMethodCd: number | null;
    bathWeeks: string;
    bathDays: string;
    priorityCd: number | null;
    treatmentNotes: string | null;
    insStfCd: string | null;
    insDate: string | null;
    updStfCd: string | null;
    updDate: string | null;
    type: string | null;
    recordDate: string | null
}

// BathMaster.ts
export class BathMasterItem {
    PartitionKey: string = "";
    SortKey: string = "";
    BLOCKCD?: string;
    SUBCD?: string;
    UNITCD?: string;
    BATHNAME?: string;
    CAPACITY?: number;
    SORTNO?: number;
    BATHRULE?: number;
    BATHDAIS: BathDais[] = [];
    INSSTFCD?: string;
    INSDATE?: string;
    UPDSTFCD?: string;
    UPDDATE?: string;
    /**
     * Concurrency token: the version this copy of the room was loaded at. Every write of the
     * room sends it back and the server refuses the write if the stored version has moved on.
     * Null on a room stored before the field existed. UPDDATE is audit display only.
     */
    ITEMVER?: number | null;
}

export class BathDais {
    DAICD?: string;
    BATHMETHODCD?: number;
    BATHWEEKS?: string;
    BATHDAYS?: string;
    PRIORITYCD?: number;
    TREATMENTNOTES?: string;
    /** Order stamp written only by the apply-date flow (phase 5). Carried forward verbatim otherwise. */
    APPLYSEQ?: number;
}

export class BathMaster extends BathMasterItem {
    DaiTable: string = "";
}

export class BathDaiUpdate extends BathDais {
    PartitionKey: string = "";
    SortKey: string = "";
    /**
     * ITEMVER of the bathroom this edit was composed against. The server refuses the save
     * if the bathroom has changed since, so the user can reload and redo it. Null means the
     * bathroom was stored before the field existed.
     */
    ITEMVER?: number | null;
    /** Office type as the client resolves it (Utils.isNyusho); drives the propagation horizon and schedule rule. */
    IsNyuSho: boolean = false;
}

/**
 * Counts returned by a dai save for the future days it propagated to. Absent/null when the
 * server wrote no day. `conflicted` is the only channel that reports a day the save could not
 * take, so it must always reach the user.
 */
export interface BathDaiApplyResult {
    updated: number;
    added?: number;
    removed?: number;
    skipped: number;
    conflicted: number;
    superseded: number;
    daiNotFound: number;
    /** SKs (date_yyyyMMdd) whose snapshot was refreshed. */
    days: string[];
    /** Cells counted in `updated`, as bathroom_{uid}/date_{yyyyMMdd}: same days as `days` but with the room, for grouping. */
    updatedCells?: string[];
    /** Cells as bathroom_{uid}/date_{yyyyMMdd}. */
    addedCells?: string[];
    removedCells?: string[];
    conflictedCells?: string[];
    /**
     * True when the master row was saved but propagation could not run (the counts are then 0 or a
     * partial result). The client keeps the new ITEMVER and warns the user to check 入浴管理.
     * Absent on responses from an API version before this field existed.
     */
    planFailed?: boolean;
    /**
     * Cells that threw, exhausted their throttle attempts, or were cancelled by the deadline. Their
     * state is unconfirmed - the client re-reads them. Distinct from `conflicted` (lost ITEMVER guard).
     */
    failed?: number;
    /** Cells counted in `failed`, as bathroom_{uid}/date_{yyyyMMdd}. */
    failedCells?: string[];
    /** Cells counted in `superseded`, as bathroom_{uid}/date_{yyyyMMdd}: left unchanged because a newer save already wrote them. */
    supersededCells?: string[];
}

/** Response of update-bathdai. */
export interface BathDaiUpdateResult {
    itemVer?: number | null;
    updDate?: string | null;
    apply?: BathDaiApplyResult | null;
}

/** Response of move-bathdai. For a move within one room both versions are the same. */
export interface BathDaiMoveResult {
    sourceItemVer?: number | null;
    targetItemVer?: number | null;
    sourceUpdDate?: string | null;
    targetUpdDate?: string | null;
    apply?: BathDaiApplyResult | null;
}

/**
 * Asks the server what a dai edit would do to the existing future days, before saving. Source
 * and target keys are equal for an update in place; BATHWEEKS/BATHDAYS are the NEW pattern.
 */
export class BathDaiChangePreviewRequest {
    SourcePartitionKey: string = "";
    SourceSortKey: string = "";
    TargetPartitionKey: string = "";
    TargetSortKey: string = "";
    DAICD?: string;
    BATHWEEKS?: string | null;
    BATHDAYS?: string | null;
    IsNyuSho: boolean = false;
}

/** Response of preview-bathdai-change (camelCase as serialized). Dates are yyyyMMdd. */
export interface BathDaiChangePreviewResult {
    horizonFrom?: string | null;
    horizonTo?: string | null;
    /** Present only when the room changes. Calendar prediction: every horizon date the old / new pattern covers, existing day or not. */
    roomChange?: {
        fromRoomName?: string | null;
        toRoomName?: string | null;
        removed: string[];
        added: string[];
        /** Days (ascending) the move would create in the target room; not part of `added`. */
        created?: string[];
    } | null;
    /** Present only when the basic days change. */
    patternChange?: {
        oldWeeks?: string | null;
        oldDays?: string | null;
        newWeeks?: string | null;
        newDays?: string | null;
        removed: string[];
        added: string[];
    } | null;
}

/**
 * Moves a dai from one bathroom to another. The inherited BathDais fields carry the
 * settings the dai must have in the target bathroom.
 */
export class BathDaiMove extends BathDais {
    SourcePartitionKey: string = "";
    SourceSortKey: string = "";
    TargetPartitionKey: string = "";
    TargetSortKey: string = "";
    /**
     * ITEMVERs of the two bathrooms as last loaded. The move rewrites both, so both must
     * still match for it to be applied.
     */
    SourceITEMVER?: number | null;
    TargetITEMVER?: number | null;
    /** Office type as the client resolves it (Utils.isNyusho); drives the propagation horizon and schedule rule. */
    IsNyuSho: boolean = false;
    /**
     * yyyyMMdd of preview `created` days the user unticked: the dai still leaves the source room
     * on those days but no target day is created. Null/absent creates every such day.
     */
    SkipCreateDates?: string[] | null;
}

// BathDaily.ts
export interface IDynamodbBaseEntity {
    PartitionKey: string;
    SortKey: string;
    INSSTFCD?: string;
    INSDATE?: string;
    UPDSTFCD?: string;
    UPDDATE?: string;
}

export class BathDailyItem implements IDynamodbBaseEntity {
    PartitionKey: string = "";
    SortKey: string = "";
    DAIS: DAIS[] = [];
    INSSTFCD?: string;
    INSDATE?: string;
    UPDSTFCD?: string;
    UPDDATE?: string;
    /**
     * Concurrency token: the version this day was loaded at. upsert-logs sends it back per day
     * and the server refuses that day (outcome "conflict", currentItemVer) if the stored
     * version has moved on - the day-list replaces the whole entry list, so a stale list must
     * never overwrite an entry someone else added. Absent on a NEW_ day and on a day stored
     * before the field existed.
     */
    ITEMVER?: number | null;
    /** 2 once any entry carries a snapshot. Absent/other means every entry still reads live master. */
    SCHEMAVER?: number | null;
    /**
     * Set whenever a write changes this day's DAIS, or an apply-date refresh touches a
     * snapshot. Every upsert-logs write of the day clears it server-side; until then
     * bathe-management recomputes validity of the day's entries for display only.
     */
    NEEDSRECALC?: boolean | null;
    /**
     * DAICDs a dai move placed on a day it created in the target room. While set and the day is
     * not past, the day renders like a day with no BathDaily (generated from the room master)
     * plus these entries always valid at the end. Stored as a set: order is not meaningful, the
     * entries' own SORTNO orders them. Every upsert-logs write clears it server-side; never send it.
     */
    FORCEVALIDDAIS?: string[] | null;
}

export class DAIS {
    DAICD?: string;
    BATHMETHODCD: number = 0;
    SORTNO: number = 0;
    ISVALID?: boolean; // Flag to track if this dai is valid for display based on yotei

    // Snapshot fields (phase 3). Nullable: absent on a legacy/unsnapshotted entry.
    // Read only when the owning day's SCHEMAVER === 2 AND this entry's MASTERUPDDATE
    // is set - see dai-snapshot.helper.ts. Never write these from a hand-built payload;
    // the server clears any inbound snapshot fields before merging.
    BATHWEEKS?: string | null;
    BATHDAYS?: string | null;
    PRIORITYCD?: number | null;
    TREATMENTNOTES?: string | null;
    BLOCKCD?: string | null;
    UNITCD?: string | null;
    /** Owning room's name, frozen with BLOCKCD/UNITCD when this entry is snapshotted. */
    BATHNAME?: string | null;
    /** Provenance: the master's UPDDATE this entry's snapshot was taken from. */
    MASTERUPDDATE?: string | null;
    /** Order stamp, written only by the propagation flow. Carried forward verbatim. */
    APPLYSEQ?: number | null;
    /**
     * Entry-level recompute flag, raised by the server when a dai move appended or refreshed this
     * entry without flagging the whole day. On a day whose own NEEDSRECALC is not set, only entries
     * carrying this flag get their ISVALID recomputed for display; the day-list write-back clears
     * both flags. Never sent from a hand-built payload (the server strips it anyway).
     */
    NEEDSRECALC?: boolean | null;

    /**
     * Request-only hint for a cross-room daily move: the uid of the bathroom this resident was
     * dragged in FROM. Set only on an entry moved into a room whose master does not list this dai,
     * so the server knows which source room's master to freeze the config from. Never stored (the
     * server drops it) and never present on an entry read back from the server.
     */
    SOURCEBATHROOMUID?: string | null;
}

export class DAISWithKeys extends DAIS {
    PartitionKey: string = "";
    SortKey: string = "";
}

export class BathDaily extends BathDailyItem {
    LogTable: string = "";
}

/**
 * Additive per-item fields the upsert-logs response now carries alongside the full
 * BathDaily fields (logTable, insstfcd, etc. - unchanged, still present). `outcome` is
 * absent on servers that predate this field; treat that as "written". `conflict` is a lost
 * version race, `failed` a server-side error - both reload the day, with different wording.
 */
export type UpsertLogOutcome = 'written' | 'conflict' | 'notFound' | 'failed';

/** Deletes one bathroom of the caller's own office; the server takes corp/office from the headers. */
export class DeleteBathroom
{
    BathroomUID?: string

    /**
     * ITEMVER the screen's copy of the bathroom was loaded at. The server refuses the
     * delete if someone has edited the room since, so the user can be warned before
     * discarding work they have not seen.
     */
    ITEMVER?: number | null
}

export class UserYoteiConfig {
    objcd!: string;
    blockcd!: string;
    subcd!: string;
    unitcd!: string;
    sdate!: string | Date;
    edate!: string | Date;
    resultatr?: string;
    index?: number;

    constructor(data?: Partial<UserYoteiConfig>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}